"use client";

var __jsx = React.createElement;
import React from "react";

// import RetailHeaderCartButton from '@modules/retail/layout/components/header/cart-button'
import HeaderAccountButton from "@modules/layout/components/header/components/account-button";
import HeaderConfigButtons from "../config-buttons";
import { usePathname } from "navigation";
import APP_CONFIGURATION from "@lib/app.config";
import useCssModules from "@lib/hooks/use-css-modules";
const HeaderActions = _ref => {
  let {
    additionalButtons = __jsx(React.Fragment, null),
    additionalDropdownItems = [],
    customerIsLogged,
    allowUnauthenticatedCustomer,
    smallDisplay
  } = _ref;
  const pathname = usePathname();
  const {
    cssModules
  } = useCssModules();
  const {
    headerDivisionClassNames
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.account.header) || {};
  const showConfigsButtons = () => {
    if (smallDisplay) {
      return false;
    }
    const splitPathname = pathname.split("/");
    if (splitPathname.includes("checkout")) {
      return false;
    }
    return true;
  };
  return __jsx("div", {
    className: "header-element header-account-settings min-w-max"
  }, customerIsLogged && __jsx(React.Fragment, null, __jsx(HeaderAccountButton, {
    dataTestId: "header-account-button",
    additionalDropdownItems: additionalDropdownItems
  }), additionalButtons, showConfigsButtons() && !smallDisplay && __jsx("div", {
    className: headerDivisionClassNames
  })), allowUnauthenticatedCustomer && !customerIsLogged && !APP_CONFIGURATION.config.demo ? __jsx(HeaderConfigButtons, null) : null, customerIsLogged && showConfigsButtons() && !APP_CONFIGURATION.config.demo && __jsx(HeaderConfigButtons, null));
};
export default HeaderActions;